var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M13.6,9.9H9.5c-0.3,0-0.6,0.3-0.6,0.6v2.9H8.3c-0.3,0-0.6,0.2-0.6,0.5v20.7c0,0.3,0.3,0.6,0.6,0.6h1.8v1.7 c0,0.3,0.3,0.6,0.6,0.6h26c0.3,0,0.6-0.3,0.6-0.6V16.2c0-0.3-0.3-0.5-0.6-0.5h-1.8v-1.8c0-0.3-0.3-0.5-0.6-0.5h-0.6v-2.9 c0-0.3-0.3-0.6-0.6-0.6H29V8.2c0-0.3-0.3-0.6-0.6-0.6H26c-0.3,0-0.6,0.3-0.6,0.6v1.7h-2.3V8.2c0-0.3-0.3-0.6-0.6-0.6h-2.4 c-0.3,0-0.6,0.3-0.6,0.6v1.7h-2.3V8.2c0-0.3-0.3-0.6-0.6-0.6h-2.4c-0.3,0-0.6,0.3-0.6,0.6V9.9z M36.1,36.4H11.2v-1.2h18.4L30,35 l4.7-4.6c0.1-0.1,0.2-0.2,0.2-0.4V16.7h1.2V36.4z M30.2,30.5h2.7l-2.7,2.6V30.5z M33.7,29.5h-4.1c-0.3,0-0.6,0.2-0.6,0.5V34H8.9 V14.5h24.8V29.5z M26.6,8.7h1.2V11h-1.2V8.7z M20.7,8.7h1.2V11h-1.2V8.7z M19.5,11v0.5c0,0.3,0.3,0.6,0.6,0.6h2.4 c0.3,0,0.6-0.3,0.6-0.6V11h2.3v0.5c0,0.3,0.3,0.6,0.6,0.6h2.4c0.3,0,0.6-0.3,0.6-0.6V11h3.5v2.3H10.1V11h3.5v0.5 c0,0.3,0.3,0.6,0.6,0.6h2.4c0.3,0,0.6-0.3,0.6-0.6V11H19.5z M16,8.7V11h-1.2V8.7H16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M36.1,16.7h-1.2V30c0,0.2-0.1,0.3-0.2,0.4L30,35l-0.4,0.2H11.2v1.2h24.9V16.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 26.6,
  y: 8.7,
  fill: "#FFFFFF",
  width: 1.2,
  height: 2.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 20.7,
  y: 8.7,
  fill: "#FFFFFF",
  width: 1.2,
  height: 2.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.8,
  y: 8.7,
  fill: "#FFFFFF",
  width: 1.2,
  height: 2.3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M17.2,11.5c0,0.3-0.3,0.6-0.6,0.6h-2.4c-0.3,0-0.6-0.3-0.6-0.6V11h-3.5v2.3h22.4V11H29v0.5 c0,0.3-0.3,0.6-0.6,0.6H26c-0.3,0-0.6-0.3-0.6-0.6V11h-2.3v0.5c0,0.3-0.3,0.6-0.6,0.6h-2.4c-0.3,0-0.6-0.3-0.6-0.6V11h-2.3V11.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M8.9,14.5V34H29V30c0-0.3,0.3-0.5,0.6-0.5h4.1v-15H8.9z M32.5,16.2v2.3c0,0.3-0.3,0.6-0.6,0.6h-2.3 c-0.3,0-0.6-0.3-0.6-0.6v-2.3c0-0.3,0.3-0.5,0.6-0.5h2.3C32.3,15.7,32.5,15.9,32.5,16.2z M32.5,23c0,0.3-0.3,0.6-0.6,0.6h-2.3 c-0.3,0-0.6-0.3-0.6-0.6v-2.3c0-0.3,0.3-0.5,0.6-0.5h2.3c0.4,0,0.6,0.2,0.6,0.5V23z M32.5,27.7c0,0.3-0.3,0.6-0.6,0.6h-2.3 c-0.3,0-0.6-0.3-0.6-0.6v-2.3c0-0.3,0.3-0.6,0.6-0.6h2.3c0.3,0,0.6,0.3,0.6,0.6V27.7z M17.8,32.9h-2.4c-0.3,0-0.6-0.3-0.6-0.6V30 c0-0.3,0.3-0.5,0.6-0.5h2.4c0.3,0,0.5,0.2,0.5,0.5v2.3C18.3,32.5,18.1,32.8,17.8,32.9z M13,32.9h-2.3c-0.3,0-0.6-0.3-0.6-0.6V30 c0-0.3,0.3-0.6,0.6-0.6H13c0.3,0,0.6,0.3,0.6,0.6v2.2C13.6,32.6,13.3,32.9,13,32.9z M10.1,25.4c0-0.3,0.3-0.6,0.6-0.6H13 c0.3,0,0.6,0.3,0.6,0.6v2.3c0,0.3-0.3,0.6-0.6,0.6h-2.3c-0.3,0-0.6-0.3-0.6-0.6V25.4z M10.1,20.7c0-0.3,0.2-0.5,0.6-0.5H13 c0.3,0,0.6,0.2,0.6,0.5V23c0,0.3-0.3,0.6-0.6,0.6h-2.3c-0.3,0-0.6-0.3-0.6-0.6V20.7z M24.9,15.7h2.3c0.3,0,0.6,0.2,0.6,0.5v2.3 c0,0.3-0.3,0.6-0.6,0.6h-2.3c-0.3,0-0.6-0.3-0.6-0.6v-2.3C24.3,15.9,24.5,15.7,24.9,15.7z M27.8,23c0,0.3-0.3,0.6-0.6,0.6h-2.3 c-0.3,0-0.6-0.3-0.6-0.6v-2.3c0-0.3,0.2-0.5,0.6-0.5h2.3c0.3,0,0.6,0.2,0.6,0.5V23z M14.8,25.4c0-0.3,0.3-0.6,0.6-0.6h2.4 c0.3,0,0.5,0.3,0.5,0.6v2.3c0,0.3-0.2,0.6-0.5,0.6h-2.4c-0.3,0-0.6-0.3-0.6-0.6V25.4z M14.8,20.7c0-0.3,0.3-0.5,0.6-0.5h2.4 c0.3,0,0.5,0.2,0.5,0.5V23c0,0.3-0.2,0.6-0.5,0.6h-2.4c-0.3,0-0.6-0.3-0.6-0.6V20.7z M23.1,23c0,0.3-0.3,0.6-0.6,0.6h-2.4 c-0.3,0-0.6-0.3-0.6-0.6v-2.3c0-0.3,0.3-0.5,0.6-0.5h2.4c0.3,0,0.6,0.2,0.6,0.5V23z M19.5,25.4c0-0.3,0.3-0.6,0.6-0.6h2.4 c0.3,0,0.6,0.3,0.6,0.6v2.3c0,0.3-0.3,0.6-0.6,0.6h-2.4c-0.3,0-0.6-0.3-0.6-0.6V25.4z M24.9,28.2c-0.3,0-0.6-0.3-0.6-0.6v-2.3 c0-0.3,0.3-0.6,0.6-0.6h2.3c0.3,0,0.6,0.3,0.6,0.6v2.3c0,0.3-0.3,0.6-0.6,0.6H24.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "32.9,30.5 30.2,30.5 30.2,33.2  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M10.7,23.7H13c0.3,0,0.6-0.3,0.6-0.6v-2.3c0-0.3-0.3-0.5-0.6-0.5h-2.3c-0.4,0-0.6,0.2-0.6,0.5V23 C10.1,23.4,10.4,23.7,10.7,23.7z M12.4,22.5h-1.2v-1.1h1.2V22.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11.2,
  y: 21.4,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M15.4,23.7h2.4c0.3,0,0.5-0.3,0.5-0.6v-2.3c0-0.3-0.2-0.5-0.5-0.5h-2.4c-0.3,0-0.6,0.2-0.6,0.5V23 C14.8,23.4,15.1,23.7,15.4,23.7z M17.2,22.5H16v-1.1h1.2V22.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 21.4,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M22.5,20.2h-2.4c-0.3,0-0.6,0.2-0.6,0.5V23c0,0.3,0.3,0.6,0.6,0.6h2.4c0.3,0,0.6-0.3,0.6-0.6v-2.3 C23.1,20.5,22.8,20.2,22.5,20.2z M21.9,22.5h-1.2v-1.1h1.2V22.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 20.7,
  y: 21.4,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27.2,20.2h-2.3c-0.4,0-0.6,0.2-0.6,0.5V23c0,0.3,0.3,0.6,0.6,0.6h2.3c0.3,0,0.6-0.3,0.6-0.6v-2.3 C27.8,20.5,27.5,20.2,27.2,20.2z M26.6,22.5h-1.2v-1.1h1.2V22.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 25.4,
  y: 21.4,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M31.9,20.2h-2.3c-0.3,0-0.6,0.2-0.6,0.5V23c0,0.3,0.3,0.6,0.6,0.6h2.3c0.3,0,0.6-0.3,0.6-0.6v-2.3 C32.5,20.5,32.3,20.2,31.9,20.2z M31.4,21.4v1.1h-1.2v-1.1H31.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 21.4,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M24.3,16.2v2.3c0,0.3,0.3,0.6,0.6,0.6h2.3c0.3,0,0.6-0.3,0.6-0.6v-2.3c0-0.3-0.3-0.5-0.6-0.5h-2.3 C24.5,15.7,24.3,15.9,24.3,16.2z M26.6,17.9h-1.2v-1.2h1.2V17.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 25.4,
  y: 16.7,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M31.9,15.7h-2.3c-0.3,0-0.6,0.2-0.6,0.5v2.3c0,0.3,0.3,0.6,0.6,0.6h2.3c0.3,0,0.6-0.3,0.6-0.6v-2.3 C32.5,15.9,32.3,15.7,31.9,15.7z M31.4,16.7v1.2h-1.2v-1.2H31.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 16.7,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M10.7,28.2H13c0.3,0,0.6-0.3,0.6-0.6v-2.3c0-0.3-0.3-0.6-0.6-0.6h-2.3c-0.3,0-0.6,0.3-0.6,0.6v2.3 C10.1,28,10.4,28.2,10.7,28.2z M11.2,27.1V26h1.2v1.2H11.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11.2,
  y: 26,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M15.4,28.2h2.4c0.3,0,0.5-0.3,0.5-0.6v-2.3c0-0.3-0.2-0.6-0.5-0.6h-2.4c-0.3,0-0.6,0.3-0.6,0.6v2.3 C14.8,28,15.1,28.2,15.4,28.2z M16,26h1.2v1.2H16V26z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 26,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M13.6,30c0-0.3-0.3-0.6-0.6-0.6h-2.3c-0.3,0-0.6,0.3-0.6,0.6v2.2c0,0.3,0.3,0.6,0.6,0.6H13 c0.3,0,0.6-0.3,0.6-0.6V30z M11.2,30.5h1.2v1.2h-1.2V30.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11.2,
  y: 30.5,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M18.3,30c0-0.3-0.2-0.5-0.5-0.5h-2.4c-0.3,0-0.6,0.2-0.6,0.5v2.3c0,0.3,0.3,0.6,0.6,0.6h2.4 c0.3,0,0.5-0.3,0.5-0.6V30z M16,30.5h1.2v1.2H16V30.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 30.5,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M20.1,28.2h2.4c0.3,0,0.6-0.3,0.6-0.6v-2.3c0-0.3-0.3-0.6-0.6-0.6h-2.4c-0.3,0-0.6,0.3-0.6,0.6v2.3 C19.5,28,19.8,28.2,20.1,28.2z M20.7,26h1.2v1.2h-1.2V26z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 20.7,
  y: 26,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27.2,28.2c0.3,0,0.6-0.3,0.6-0.6v-2.3c0-0.3-0.3-0.6-0.6-0.6h-2.3c-0.3,0-0.6,0.3-0.6,0.6v2.3 c0,0.3,0.3,0.6,0.6,0.6H27.2z M25.4,26h1.2v1.2h-1.2V26z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 25.4,
  y: 26,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M31.9,24.7h-2.3c-0.3,0-0.6,0.3-0.6,0.6v2.3c0,0.3,0.3,0.6,0.6,0.6h2.3c0.3,0,0.6-0.3,0.6-0.6v-2.3 C32.5,25,32.2,24.7,31.9,24.7z M31.4,26v1.2h-1.2V26H31.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 26,
  fill: "#FFFFFF",
  width: 1.2,
  height: 1.2
}));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6d60c9c545f59af3b342533a5b71df98.svg";
export { ForwardRef as ReactComponent };